<template>
  <div id="login">
    <div class="container form-signin">
      <form>
        <!-- 登入身分 -->
        <label class="pd-4 line-h">
          登入身分
          <span class="spanfs">
            (Login Identity)：<br>{{ Identity_Type }}
          </span>
        </label>
        <!-- 帳號 -->
        <label for="UserId" class="sr-only">帳號</label>
        <input
          id="UserId"
          class="form-control"
          type="text"
          v-model="LoginData.UserId"
          :placeholder="Identity_Remark"
          :title="identity === 'Alumni' ? '請輸入身分證字號' : ''"
          required
          autofocus
        >
        <!-- 密碼 -->
        <label for="password" class="sr-only">密碼</label>
        <input
          id="password"
          class="form-control"
          type="password"
          v-model="LoginData.UserPasswd"
          :placeholder="PasswordPlaceholder"
          @keyup.enter="ClickEnter"
          :title="identity === 'Alumni' ? '請輸入民國出生年月日(共7碼，例：民國80年1月1日，請輸入0800101)' : ''"
          required
          autocomplete
        >
      </form>
      <!-- 記住我 -->
      <div class="checkbox  lh-fs">
        <label>
          <input
            type="checkbox"
            v-model="Checked"
            :true-value="'1'"
            :false-value="'2'"
          >
          記住我
          <v-font
            font-css="spanfss"
            font-text="(Remember me)"
          />
          <v-button
            btn-text="忘記密碼"
            btn-type="link"
            data-toggle="modal"
            data-target="#ForgetPW"
          >
            <v-font
              slot="eg"
              font-css="spanfss"
              font-text="(Forgot your password?)"
            />
          </v-button>
        </label>
      </div>
      <!-- 登入 -->
      <v-button
        class="lh-fs mr-2"
        btn-text="登入"
        btn-type="primary"
        btn-size="lg"
        btn-block="true"
        @click.native="PostAccountLogin"
      >
        <span
          slot="eg"
          class="spanfs"
        >
          <br>(Login)
        </span>
      </v-button>
      <div
        v-if="IsShowRegistration"
        class="text-center mt-3"
      >
        <small class="text-muted student-login-text ">
          還沒有帳號？
          <router-link
            to="/home/registration"
            class="font-weight-bold text-primary"
          >
            點此註冊
            <v-font font-css="spanfss" font-text="(Register)" />
          </router-link>
        </small>
      </div>

      <!-- 在校生密碼修改提示 -->
      <div
        v-if="identity === 'school'"
        class="text-center mt-3 student-login-tip"
      >
        <small class="text-danger student-login-text">
          無法登入請至
          <a
            href="https://aca.nuk.edu.tw/Student2/login.asp"
            target="_blank"
            rel="noopener noreferrer"
            class="font-weight-bold"
          >
            學生教務系統
          </a>
          修改密碼
        </small>
      </div>

      <!--校友登入說明 -->
      <div
        v-if="identity === 'Alumni'"
        class=" mt-3 alumni-login-guide"
      >
        <div class="divider-text text-center">
          <span >─────────  登入說明 ─────────</span>
        </div>
        <small class="text-muted alumni-guide-text">
          <div class="guide-item">
            <strong>帳號:</strong> 身分證字號
          </div>
          <div class="guide-item">
            <strong>密碼:</strong> 民國出生年月日(共7碼)
          </div>
          <div class="guide-example">
            例：民國80年1月1日，請輸入
            <span class="text-primary font-weight-bold">0800101</span>
          </div>
        </small>
      </div>
    </div>

    <!-- 忘記密碼Modal -->
    <v-modal id="ForgetPW">
      <div slot="header">
        忘記密碼
      </div>
      <div slot="body">
        <label
          for="ForgetID"
          class="col-form-label"
        >
          <v-small />
          請輸入帳號:
        </label>
        <input
          id="ForgetID"
          type="text"
          class="form-control"
          v-model="ForgetID.UserId"
        >
        <label
          for="ForgetEmail"
          class="col-form-label"
        >
          <v-small />
          請輸入信箱:
        </label>
        <input
          id="ForgetEmail"
          type="text"
          class="form-control"
          v-model="ForgetID.Email"
        >
      </div>
      <div slot="footer">
        <v-button
          class="mr-2"
          btn-text="取消"
          btn-type="secondary"
          data-dismiss="modal"
        />
        <v-button
          btn-text="送出"
          btn-type="primary"
          @click.native="PostAccountForgetpw"
        />
      </div>
    </v-modal>
  </div>
</template>

<script>
import vSmall from '@/components/Features/Small'
import vModal from '@/components/Features/ModalFloot'
import { apiAccountLogin, apiAccountForgetpw } from '../../Api/api'
import $ from 'jquery'
import md5 from 'js-md5'
export default {
  props: {
    identity: {
      type: String,
      default: ''
    }
  },
  components: {
    vModal,
    vSmall
  },
  computed: {
    // 只有一般民眾和廠商才顯示註冊連結
    IsShowRegistration () {
      return this.identity === 'Naturalpersons' || this.identity === 'firm'
    },
    // 根據身分顯示不同的密碼提示文字
    PasswordPlaceholder () {
      if (this.identity === 'Alumni') {
        return '民國出生年月日(共7碼)'
      } else {
        return 'Password'
      }
    }
  },
  data () {
    return {
      Identity_Type: '', // 帳號身分
      Identity_Remark: '', // 登入系統
      LoginData: { // 登入API資料
        APIVer: '0',
        ClientIP: '',
        UserType: null,
        UserId: localStorage.getItem('M_KeepUserId') ? localStorage.getItem('M_KeepUserId') : '',
        UserPasswd: '',
        Timeout: 100 // 帳號停留時間
      },
      ForgetID: { // 忘記密碼
        UserId: '',
        Email: ''
      },
      UserData: {}, // Nav資料
      Identity: {}, // API預設資料
      Checked: localStorage.getItem('M_checked') ? localStorage.getItem('M_checked') : '2'
    }
  },
  created () {
    this.Identification()
    const LoginIP = this.LoginData
    $.getJSON('https://api.ipify.org?format=jsonp&callback=?', function (data) {
      LoginIP.ClientIP = data.ip
    })
  },
  methods: {
    ClickEnter () { // 輸入欄位鍵盤觸發
      this.PostAccountLogin()
    },
    Identification () { // 登入身分辨識
      const vm = this
      const LoginType = vm.LoginData
      // localStorage 'M_UserType'：用來開啟個人管理頁面的變更密碼
      // 只有廠商跟個人，其餘身分預防影響設定，預設刪除localStorage 'M_UserType'
      switch (vm.identity) {
        case 'school':
          vm.Identity_Type = '在校生(Student)'
          vm.Identity_Remark = '教務系統帳號'
          LoginType.UserType = 1
          localStorage.removeItem('M_UserType')
          break
        case 'teacher':
          vm.Identity_Type = '教師(Faculty)'
          vm.Identity_Remark = '教務系統帳號'
          LoginType.UserType = 2
          localStorage.removeItem('M_UserType')
          break
        case 'Staff':
          vm.Identity_Type = '職員(Staff)'
          vm.Identity_Remark = '校務行政系統帳號'
          LoginType.UserType = 3
          localStorage.removeItem('M_UserType')
          break
        case 'Alumni':
          vm.Identity_Type = '校友(Alumni)'
          vm.Identity_Remark = '身分證字號'
          LoginType.UserType = 4
          localStorage.removeItem('M_UserType')
          break
        case 'Naturalpersons':
          vm.Identity_Type = '一般民眾(General Public)'
          vm.Identity_Remark = '本系統註冊帳號'
          LoginType.UserType = 5
          localStorage.setItem('M_UserType', '5')
          break
        case 'firm':
          vm.Identity_Type = '廠商(Vendor)'
          vm.Identity_Remark = '本系統註冊帳號'
          LoginType.UserType = 6
          localStorage.setItem('M_UserType', '6')
      }
    },
    PostAccountLogin () { // 登入 F_API 001
      const vm = this
      const Login = vm.LoginData
      // 防呆-帳號密碼
      if (Login.UserId === '' || Login.UserPasswd === '') {
        vm.$bus.$emit('Modals', '帳密不得為空值')
        $('#CheckError').modal('show')
      } else {
        // 設定-記住我
        if (vm.Checked === '1') { // true
          localStorage.setItem('M_KeepUserId', Login.UserId)
          localStorage.setItem('M_checked', '1')
        } else { // false
          localStorage.removeItem('M_KeepUserId')
          localStorage.setItem('M_checked', '2')
        }
        // 呼叫API
        apiAccountLogin(Login).then(
          res => {
            if (res !== undefined) {
              // 紀錄API資訊
              vm.Identity.APIVer = '0'
              vm.Identity.ClientIP = Login.ClientIP
              vm.Identity.UserId = res.UserId
              vm.Identity.Token = res.Token
              localStorage.setItem('M_Identity', JSON.stringify(vm.Identity))
              // 紀錄帳號資訊
              const Userdata = {}
              Userdata.UserId = res.UserId
              Userdata.UserName = res.UserName
              localStorage.setItem('M_UserData', JSON.stringify(Userdata))
              // 紀錄權限
              var Privilege = ''
              if (res.BackendPrivilege === 0) {
                Privilege = md5('無權限')
              } else {
                Privilege = md5('有權限')
              }
              localStorage.setItem('M_BackendPrivilege', Privilege)
              // 登入資訊變換
              vm.$bus.$emit('LoginUser', 'true')
              // 防呆-帳號Email不得空值，導向個人帳號，Menu不觸發
              if (res.Email === '' || res.Email === undefined || res.Telephone === '' || res.Telephone === undefined) {
                vm.$bus.$emit('Modals', '帳號Email、電話為必要資訊，煩請更新Email、電話，並重新登入。')
                $('#CheckError').modal('show')
                // localStorage.setItem('CheckEmail', true)
                vm.$router.push({ name: 'Account_User' })
                return false
              } else {
                vm.$bus.$emit('LoginCheckUser', 'true')
                // Menu變換
                localStorage.setItem('M_Menu', 'true')
                // 導向 證件申請頁面
                vm.$bus.$emit('messsage:push', '登入成功', 'primary')
                vm.$router.push({ name: 'Feeorder_Personal' })
                // window.location.reload(true)
              }
            } else {
              $('#CheckError').modal('show')
            }
          }
        )
      }
    },
    PostAccountForgetpw () { // 忘記密碼
      // 定義資料
      const vm = this
      const NewData = vm.ForgetID
      $('#ForgetPW').modal('hide')
      if (NewData.UserId !== '' && NewData.Email !== '') {
        // 呼叫API
        apiAccountForgetpw(NewData).then(
          res => {
            if (res !== undefined) {
              vm.$bus.$emit('Modals', '密碼修改成功，請至您的email信箱收取密碼異動通知信。')
              $('#CheckOk').modal('show')
            } else {
              $('#CheckError').modal('show')
            }
          }
        )
      } else {
        vm.$bus.$emit('Modals', '帳號或信箱為必填選項。')
        $('#CheckError').modal('show')
      }
    }
  }
}
</script>

<style lang="scss">
html,
body {
  height: 100%;
  background-color:#f1f1f1;
}
#login {
  display: -webkit-box;
  -ms-flex-align: center;
  -ms-flex-pack: center;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  padding-top: 40px;
  padding-bottom: 40px;
}
.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: 0 auto;
}
.form-signin .checkbox {
  font-weight: 400;
  display:flex;
}
.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 1rem;
}
.form-signin .form-control:focus {
  z-index: 2;
}
.form-signin input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.long-test {
  color: #000000c2;
  background-color: #f1f1f1;
  display: -webkit-box;
  font-size: medium;
}

.student-login-text {
  font-size: 1rem;
  line-height: 1.5;
  display: block;
}
.student-login-tip a {
  text-decoration: none;
  border-bottom: 1px solid;
}
.divider-text span {
  color: #6e6e6e;
  display: inline-block;
  white-space: nowrap;
}
</style>
